"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Container = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../../../global-files/variables");

var _templateObject;

var Container = _styledComponents.default.div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  font-family: ", ", sans-serif;\n  font-weight: 400;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  font-size: var(--size);\n  line-height: 1.2;\n  height: auto;\n  border-radius: 10px;\n  background: white;\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  text-align: center;\n  .container-buttons {\n    display: flex;\n    gap:10px;\n  }\n  .container-box{\n    display: flex;\n    flex-direction:column-reverse;\n    gap:10px;\n  }\n  #contenedor-caja {\n    display: flex;\n    justify-content: space-between;\n    color: #262626;\n    white-space: nowrap;\n    gap: 10px;\n  }\n  #atr-alto {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 6px;\n  }\n  h1 {\n    font-family: ", ", sans-serif;\n    font-size: 17px;\n    line-height: 1.2;\n    font-weight: 500;\n    text-align: left;\n  }\n"])), _variables.FontFamily.Roboto, _variables.FontFamily.RobotoMedium);

exports.Container = Container;